import "../../../utils/messages";
import { CUSTOMER_MESSAGES } from "../../../utils/messages";
import { ClientMessage } from "../../../utils/objects";
import qs from 'querystring';

export function assignCustomerRequests(api) {
    let customersBaseURL = "/enterprise/customers";
    /****************************************CUSTOMERS (ANAGRAFICA)*********************************************************/
    api.getCustomers = async function () {
        var response = await api.get(customersBaseURL, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, CUSTOMER_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.getCustomer = async function (idCustomer) {
        var response = await api.get(customersBaseURL +'/' + idCustomer, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, CUSTOMER_MESSAGES.NOT_RETRIEVED);
                return null;
            });

        return response;
    }

    api.createCustomer = async function (customer) {
        var clientMessage = ClientMessage.success(CUSTOMER_MESSAGES.CREATED, [customer.company_name]);

        var response = await api.post(
            customersBaseURL,
            JSON.stringify(customer),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            clientMessage = this.checkError(e, CUSTOMER_MESSAGES.NOT_CREATED, [customer.company_name]);
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "customermethods");

        if (response && this.vueEnvironment) this.vueEnvironment.rebuildCustomerMap();

        return response;
    }

    api.editCustomer = async function (customer) {
        var clientMessage = ClientMessage.success(CUSTOMER_MESSAGES.MODIFIED, [customer.company_name]);

        var response = await api.put(
            customersBaseURL,
            JSON.stringify(customer),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            clientMessage = this.checkError(e, CUSTOMER_MESSAGES.NOT_MODIFIED, [customer.company_name]);
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "customermethods");

        if (response && this.vueEnvironment) this.vueEnvironment.rebuildCustomerMap();

        return response;
    }

    api.deleteCustomer = async function (idCustomer, ragioneSociale) {
        var clientMessage = ClientMessage.success(CUSTOMER_MESSAGES.DELETED, [ragioneSociale]);

        var response = await api.delete(customersBaseURL+'/' + idCustomer, this.buildConfig())
            .then(res => res.status != 400)
            .catch(e => {
                clientMessage = this.checkError(e, CUSTOMER_MESSAGES.NOT_DELETED, [ragioneSociale]);
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "customermethods");

        if (response && this.vueEnvironment) this.vueEnvironment.rebuildCustomerMap();

        return response;
    }

    api.getCustomerSummary = async function (idCustomer, filters) {
        var queryString = filters != null ? '?' + qs.stringify(filters) : '';

        var response = await api.get(customersBaseURL+'/' + idCustomer + '/summary' + queryString, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, CUSTOMER_MESSAGES.SUMMARY_NOT_RETRIEVED);
                return null;
            });

        return response;
    }
}
